export { default as LoyaltyLoadingAnimation } from './loyalty-loading-animation.json';
export { default as LoyaltyPullDownLoader } from './loyalty-pull-down-loader.json';
